export default "__VITE_ASSET__D9TOuL5Y__"